import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authSlice } from '../../../../authSlice'
import { resetForgotPasswordState } from '../resetForgotPasswordState'
import { ForgotPasswordRequest } from '../ForgotPasswordRequest'
import { ForgotPasswordPassCode } from '../ForgotPasswordPassCode'
import { ForgotPasswordConfirm } from '../ForgotPasswordConfirm'
import { ForgotPasswordLogin } from '../ForgotPasswordLogin'
import { MobileAuthHeader } from '../../../mobile/MobileAuthHeader'
import { useIsMobile } from '@wellesley/ui'

const views = {
  request: ForgotPasswordRequest,
  passCode: ForgotPasswordPassCode,
  confirm: ForgotPasswordConfirm,
  login: ForgotPasswordLogin,
}

const Switch: FC = () => {
  const step = useSelector(authSlice.selectors.selectForgotPasswordStep)
  const View = views[step]

  return View ? <View /> : null
}

const Mobile: FC = () => (
  <div className="mt-12 min-h-[calc(100vh-48px)] md:hidden">
    <MobileAuthHeader />
    <div className="h-full px-4">
      <Switch />
    </div>
  </div>
)

const Desktop: FC = () => (
  <div className="flex w-auto flex-col items-center justify-center max-md:hidden">
    <Switch />
  </div>
)

export const ForgotPasswordProcess: FC = () => {
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  useEffect(() => {
    resetForgotPasswordState(dispatch)
  }, [dispatch])

  return isMobile ? <Mobile /> : <Desktop />
}
